import { WithExperiments } from '@americanexpress/react-test-and-learn';
import { useEffect } from 'react';
import { locationShape, withRouter } from '@americanexpress/one-app-router';
import { compose } from 'redux';

var FetchExperimentsOnRoute = function FetchExperimentsOnRoute(_ref) {
  var location = _ref.location,
      fetchExperiments = _ref.fetchExperiments;
  useEffect(function () {
    if (global.BROWSER) {
      fetchExperiments({
        payloadData: {
          locator: window.location.href
        }
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [location.pathname, location.search]);
  return null;
};

FetchExperimentsOnRoute.propTypes = {
  location: locationShape.isRequired
};
var FetchExperimentsOnRoute$1 = compose(withRouter, WithExperiments)(FetchExperimentsOnRoute);

export default FetchExperimentsOnRoute$1;
export { FetchExperimentsOnRoute as ComponentUnderTest };
